import { getAuthCode } from "./getAuthCode";
export const validatePayment = async(paymentId) => {
    try {
      const authCode = await getAuthCode()
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/validatePayment", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({auth_code:authCode,paymentId:paymentId}),
      });
      const result = await response.json();
    } catch (error) {
      console.log(error);
    }
}